window.URL = window.URL || window.webkitURL;

export const getFileUrl = (file: File): string => {
  return window.URL.createObjectURL(file);
}
